module.exports = __webpack_public_path__ + "img/AudiovisualComando.57c694ec.svg";